<script setup lang="ts">
import {computed} from 'vue';
import type {CartMessages} from './types/cartMessages';

const emit = defineEmits<{
  (e: 'dismiss'): void;
}>();

const props = withDefaults(
  defineProps<{
    messages: CartMessages;
    size?: 'small' | 'medium';
    backgroundColor?: string;
  }>(),
  {
    size: 'medium',
  }
);

const showMessages = computed(() => !!Object.values(props.messages).length);

const title = computed(() => {
  const messageKeys = Object.keys(props.messages);

  if (messageKeys.includes('coupon')) {
    return 'The coupon code could not be applied to your order';
  }

  return 'Some of the items in your bag are low or out of stock';
});
</script>

<template>
  <tml-dismissible-container
    v-if="showMessages"
    class="mt-4 cart-messages-container-small"
    :dismissed="!showMessages"
    @dismiss="emit('dismiss')"
  >
    <tml-card :style="{backgroundColor: backgroundColor}">
      <h4>{{ title }}</h4>
      <p v-for="(message, key) in messages" :key="key">
        {{ message.text }}
      </p>
    </tml-card>
  </tml-dismissible-container>
</template>
